@if (productPresentation) {
    <app-faq headline="Wo finde ich die Versicherungsdokumente zum Download?">
        <p>
            Hier kannst du das
            <a
                [href]="'/assets/documents/' + productPresentation.docIPIDUrl"
                target="_blank"
                rel="noreferrer noopener"
                title="Informationsblatt zu Versicherungsprodukten (PDF)"
                >Informationsblatt zu Versicherungsprodukten (PDF)</a
            >, die
            <a
                [href]="'/assets/documents/' + productPresentation.docAVBUrl"
                target="_blank"
                rel="noreferrer noopener"
                title="Allgemeine Versicherungsbedingungen (PDF)"
                >Allgemeinen Versicherungsbedingungen (PDF)</a
            >, das
            <a
                [href]="'/assets/documents/' + productPresentation.docAnzeigepflichtUrl"
                target="_blank"
                rel="noreferrer noopener"
                title="Informationsblatt zu Obliegenheiten und Anzeigepflicht (PDF)"
                >Informationsblatt zu Obliegenheiten und Anzeigepflicht (PDF)</a
            >
            und die
            <a
                [href]="'/assets/documents/' + productPresentation.docAddInfoUrl"
                target="_blank"
                rel="noreferrer noopener"
                title="Weitere Kundeninformationen (PDF)"
                >weiteren Kundeninformationen (PDF)</a
            >
            einsehen.
        </p>
    </app-faq>
    <app-faq headline="Wie alt darf mein Smartphone sein?">
        <p>
            Wir versichern neue Handys, die nicht älter als 6 Monate sind. Versicherst Du es innerhalb von 6 Wochen nach
            dem Kauf, beginnt dein Versicherungsschutz sofort. Versicherst Du es erst später, beginnt dein
            Versicherungsschutz 6 Wochen nach Abschluss des Versicherungsvertrags.
        </p>
    </app-faq>
    <app-faq headline="Gibt es Wartezeiten?">
        <p>
            Nein, wenn Du dein Smartphone innerhalb von 6 Wochen nach Kauf versicherst. Lässt Du Dir mehr Zeit, beträgt
            die Wartezeit ab Abschluss des Versicherungsvertrags 6 Wochen.
        </p>
    </app-faq>
    <app-faq headline="Gibt es eine Kündigungsfrist?">
        <p>Der Versicherungsvertrag kann täglich zum Ende des Monats gekündigt werden.</p>
    </app-faq>
    <app-faq headline="Ist Diebstahl versichert?">
        <p>
            Ja, Diebstahl ist versichert, wenn du die Option bei Abschluss gewählt hast und die Ortungsfunktion deines
            Smartphones aktiviert ist.
        </p>
    </app-faq>
    <app-faq headline="Welche Unterlagen muss ich einreichen, wenn das Gerät geklaut wurde?">
        <p>
            Im Falle eines Diebstahls benötigen wir eine polizeiliche Anzeige. Die Ortungsfunktion deines Handys muss
            aktiviert sein, um den letzten Standort nachzuweisen. Zusätzlich benötigen wir einen Nachweis von Dir, dass
            die Daten auf dem Gerät gelöscht wurden.
        </p>
    </app-faq>
    <app-faq headline="Gibt es eine Selbstbeteiligung?">
        <p>
            Du hast die Wahl, wir haben beides. Entweder schließt Du unseren Tarif ohne Selbstbeteiligung ab oder Du
            entscheidest Dich für die etwas günstigere Variante mit Selbstbeteiligung.
        </p>
    </app-faq>
    <app-faq headline="Gibt es Höchst&shy;entschädigungs&shy;grenzen?">
        <p>Ja, in Abhängigkeit vom Gerätealter:</p>
        <ul>
            <li>Voller Wiederbeschaffungswert bei einer Gebrauchsdauer bis zu 12&nbsp;Monaten.</li>
            <li>
                85&nbsp;% des maximalen Wiederbeschaffungswertes bei einer Gebrauchsdauer vom 13.&nbsp;Monat bis zum
                24.&nbsp;Monat.
            </li>
            <li>
                70&nbsp;% des maximalen Wiederbeschaffungswertes bei einer Gebrauchsdauer vom 25.&nbsp;Monat bis zum
                36.&nbsp;Monat.
            </li>
            <li>45&nbsp;% des maximalen Wiederbeschaffungswertes bei einer Gebrauchsdauer ab dem 37.&nbsp;Monat.</li>
        </ul>
    </app-faq>
    <app-faq headline="Was bedeutet Wiederbeschaffungswert?">
        <p>Der gegenwärtige Marktpreis eines Gerätes gleicher Art und Güte.</p>
    </app-faq>
    <app-faq headline="Wie kann ich einen Schaden melden?">
        <p>
            Bei Vertragsabschluss erhältst Du Zugangsdaten für unser Kundenportal. Der schnellste Weg ist, den Schaden
            hierrüber zu melden. Natürlich kannst du uns auch die Unterlagen per Mail an
            <a href="mailto:info@astra-versicherung.de">info&#64;astra-versicherung.de</a>
            schicken. Die Schadensmeldung sollte innerhalb von 14&nbsp;Tagen erfolgen.
        </p>
    </app-faq>
    <app-faq headline="Ist Zubehör versichert?">
        <p>
            Im üblichen Lieferumfang enthaltenes Originalzubehör ist mitversichert. Enthält das versicherte
            Originalzubehör keine Schutzhülle, keinen Displayschutz oder keine Handy-Kette, sind die Schäden bis zu
            einem Betrag von 50,-&nbsp;Euro versichert.
        </p>
    </app-faq>
    <app-faq headline="Muss ich das Geld überweisen?">
        <p>
            Nein, wir buchen die Beiträge immer am Anfang des Monats von deinem Konto ab. Du erteilst uns im
            Bestellprozess dein Lastschriftmandat. Eine andere Möglichkeit gibt es aktuell nicht.
        </p>
    </app-faq>
    <app-faq headline="Welche Handymodelle kann ich versichern?">
        <p>Alle, da haben wir uns nicht so.</p>
    </app-faq>
}
